import { createFileRoute, useParams } from '@tanstack/react-router';
import { HolderLedgerPage } from '@/features/holders/holder-ledger-page.js';

function BoxLedgerRoute(): React.JSX.Element {
  const { id } = useParams({ from: '/_app/boxes/$id/ledger' });
  return <HolderLedgerPage kind="BOX" id={id} />;
}

export const Route = createFileRoute('/_app/boxes/$id/ledger')({
  component: BoxLedgerRoute,
});
